import React, {useState} from 'react'
import "./PreLogin.scss";
import {Carousel} from "react-bootstrap";
import heartIcon from "../../Assets/img/Prelogin/hurt.png";
import starIcon from "../../Assets/img/Prelogin/star.png";

const StatsCarousel  = () => {
    const carouselItems = [
        {
            quote: "I had pushed for us to do the annual membership and after bootcamp my husband was like WOW, definitely worth every penny – I couldn't agree more! The NAPS team truly does such an amazing job of making everything so digestible, interesting and not too overwhelming. I also REALLY appreciate how consistent they all are with their information. Highly, highly recommend if you're pregnant or a new mom!",
            author: "Noelle M."
        },
        {
            quote: "Hands down the best LC I’ve ever worked with (and I worked with quite a few during this pregnancy/postpartum period) I am so grateful to Meg and to NAPS for their phenomenal work. I will be working with them exclusively from here on out and you should too!",
            author: "Azucena R."
        },
        {
            quote: "Working with NAPS was the #1 best thing I did for my postpartum mental and physical health after having my second baby!",
            author: "Ashley S."
        },
        {
            quote: "NAPS was the best investment my wife and I made into our baby! We took virtual classes and used NAPS's service before and after our baby girl was born - it helped us both so much. We are in Austin, TX so we did everything virtually, and it was just as good as being in-person. NAPS has been a life saver and is worth every penny! Their staff and service is the absolute best.",
            author: "Max K."
        },
        {
            quote: "NAPS provides incredible lactation support. The process for insurance screening and scheduling was easy and very quick. They are so knowledgeable, but more importantly they made me feel very comfortable and supported in feeding in whatever ways are best for our family. All the NAPS team members I’ve interacted with are kind, funny, and approachable. Highly recommend their services and support!",
            author: "Alison K."
        }
    ];
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <div className="stats-carousel">
            <div className="stat">
                <img src={heartIcon} alt="Heart Icon" />
                <div>
                    <p className="stat-number">10K+</p>
                    <p className="stat-text">Families Cared For</p>
                </div>
            </div>
            <div className="stat">
                <img src={starIcon} alt="Star Icon" />
                <div>
                    <p className="stat-number">180+</p>
                    <p className="stat-text">5 Star Reviews</p>
                </div>
            </div>

            <div className="quotes">
                <Carousel
                    activeIndex={activeIndex}
                    onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
                    controls={false}
                    indicators={false}
                    interval={5000}
                >
                    {carouselItems?.map((item, index) => (
                        <Carousel.Item key={index}>
                            <p className="quote">“{item.quote}”</p>
                            <p className="author">{item.author}</p>
                        </Carousel.Item>
                    ))}
                </Carousel>

                <div className="carousel-indicators">
                    {carouselItems?.map((_, index) => {
                        let className = "";
                        if (index === activeIndex) className = "active";
                        else if (
                            index === activeIndex - 1 ||
                            index === activeIndex + 1
                        )
                            className = "nearby";

                        return (
                            <button
                                key={index}
                                className={className}
                                onClick={() => setActiveIndex(index)}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    )
}


export default StatsCarousel